import { render, staticRenderFns } from "./ToDuBa.vue?vue&type=template&id=a6532864&scoped=true"
import script from "./ToDuBa.vue?vue&type=script&lang=js"
export * from "./ToDuBa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6532864",
  null
  
)

export default component.exports